module.exports = __webpack_public_path__ + "static/media/content1.5a140572.png";